module.exports = __webpack_public_path__ + "media/images/games/35gender/drawing-6d6a09309a281867a27222ca2f87d291.png";